import React from 'react';
import './AppLoader.scss';
import { useTranslation } from 'react-i18next';
import spinner from '../../assets/images/spinner.svg';

// TODO -- Need to convert this to HOC (sdo phase 2)
function AppLoader({ showText = true, loaderText = '', descriptionText = '' }) {
  const { t } = useTranslation();

  return (
    <div className="app-loader-container">
      <div className="app-loader-content">
        <img src={spinner} alt="loading" className="app-loader-spinner-img" />
        {showText && <h1>{loaderText ? loaderText : t('loader.text')} </h1>}
        {showText && (
          <p className="app-loader-descText">
            {descriptionText ? descriptionText : t('loader.text')}{' '}
          </p>
        )}
      </div>
    </div>
  );
}

export default AppLoader;
